import { OrderItem, checkSetOrderItem } from './OrderItem.model';
export { checkSetOrderItem, type OrderItem };

export enum OnlineOrderStatus {
  PENDING = 0,
  ACCEPTED = 1,
  PREPARING = 2,
  READY = 3,
  OUT_FOR_DELIVERY = 4,
  DELIVERED = 5,
  REJECTED = 90,
  CANCELLED = 99,
}

export enum OnlineOrderType {
  DELIVERY = 0,
  PICKUP = 1,
  DINE_IN = 2,
}

export enum OnlineOrderSource {
  QR_MENU = 0,
}

export interface OnlineOrder {
  id?: string;
  VenueID: string;
  PatronID?: string | null;
  DefaultCurrencyID: string;
  Type: OnlineOrderType;
  Source: OnlineOrderSource;
  Status: OnlineOrderStatus;
  AccountID?: string | null;
  TableID?: string | null;
  Description: string;
  OrderItems: OrderItem[];
  GrossAmount: number;
  DiscountAmount: number;
  TaxAmount: number;
  TaxableAmount: number;
  DeliveryFee: number;
  TipAmount?: number;
  PayableAmount: number;
  PaymentType: number;
  PaymentStatus: number;
  PaymentGatewayRef?: string | null;
  SessionID?: string | null;
  CheckNo?: number | null;
  AcceptedByStaff?: string | null;
  AcceptedAt?: string | null;
  PrepTime?: number | null; // Target ready timestamp (epoch ms)
  RejectionReason?: string | null;
  created?: string;
  updated?: string;
}

/**
 * Replicates bistronex-pos checkSetOrder:
 * Computes GrossAmount, DiscountAmount, TaxableAmount, TaxAmount, and PayableAmount
 * based on the individual OrderItems and DeliveryFee.
 */
export function checkSetOnlineOrder(order: OnlineOrder): OnlineOrder {
  let gross = 0;
  let discount = 0;
  let taxable = 0;
  let tax = 0;
  let payable = 0;

  if (order.OrderItems && order.OrderItems.length > 0) {
    for (const item of order.OrderItems) {
      checkSetOrderItem(item);
      gross += item.OrderItemGrossAmount;
      discount += item.OrderItemDiscountAmount || 0;
      taxable += item.OrderItemTaxableAmount || 0;
      tax += item.OrderItemTaxAmount || 0;
      payable += item.OrderItemTotalPayable;
    }
  }

  order.GrossAmount = Number(gross.toFixed(2));
  order.DiscountAmount = Number(discount.toFixed(2));
  order.TaxableAmount = Number(taxable.toFixed(2));
  order.TaxAmount = Number(tax.toFixed(2));
  const deliveryFee = typeof order.DeliveryFee === 'number' ? order.DeliveryFee : 0;
  order.DeliveryFee = deliveryFee;
  order.PayableAmount = Number((payable + deliveryFee).toFixed(2));

  return order;
}
